import { createContext, useContext } from 'react';

import { FlatQuestionnaireFormFieldConfig } from '../utils';
import { QuestionnaireFormFieldConfig, QuestionnnaireFormFieldAnswer } from './form-types';

export interface QuestionnaireFormContextValue {
  flatFields: FlatQuestionnaireFormFieldConfig;
  fieldsMap: Map<string, QuestionnaireFormFieldConfig>;
  questionFields: readonly QuestionnaireFormFieldConfig[];
  answers: readonly QuestionnnaireFormFieldAnswer[];
  answersMap: ReadonlyMap<string, QuestionnnaireFormFieldAnswer>;
  shouldSkipFilteringFields?: boolean;
  filtersFilter(
    config: QuestionnaireFormFieldConfig,
    answer?: QuestionnnaireFormFieldAnswer,
  ): boolean;
}

export const QuestionnnaireFormContext = createContext<QuestionnaireFormContextValue | undefined>(
  undefined,
);

export function useQuestionnnaireFormContext(context1?: QuestionnaireFormContextValue) {
  const context2 = useContext(QuestionnnaireFormContext);
  const context = context1 || context2;

  if (!context) {
    throw new Error('useQuestionnnaireFormContext must be used within a QuestionnnaireForm');
  }

  return context;
}
